import { Row, Spin, Table } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { formatarCnpjCpfIMask } from '../../../../helpers/formatador';
import { Modal } from '../../../../styles/global';
import { Button, Title } from './styles';

export default function ModalCnpjsSecundarios({
  arrayCnpjsSecundarios,
  showModalCnpjsSecundario,
  handleCloseModalCnpjsSecundario,
}) {
  const [cnpjsSecundarios, setCnpjsSecundarios] = useState([]);

  useEffect(() => {
    if (arrayCnpjsSecundarios.length >= 1) {
      setCnpjsSecundarios(
        arrayCnpjsSecundarios.map(item => ({
          ...item,
          key: item.id,
          cnpj_resumido: `${formatarCnpjCpfIMask(item.cnpj_resumido).concat(
            '/****-**'
          )} `,
        }))
      );
    }
  }, [arrayCnpjsSecundarios]);

  const closeModal = () => {
    handleCloseModalCnpjsSecundario();
  };

  const columns = [
    {
      title: 'CNPJ',
      dataIndex: 'cnpj_resumido',
      key: 'cnpj_resumido',
    },
    {
      title: 'Razão Social',
      dataIndex: 'razao_social',
      key: 'razao_social',
    },
  ];

  return (
    <>
      <Modal
        title="CNPJs Secundários"
        width={600}
        onCancel={closeModal}
        visible={showModalCnpjsSecundario}
        destroyOnClose={true}
        footer={[
          <>
            <Button key="submit" onClick={closeModal} borderradius="4px">
              Fechar
            </Button>
          </>,
        ]}
      >
        <Row justify="center">
          {arrayCnpjsSecundarios && arrayCnpjsSecundarios.length >= 1 ? (
            <>
              <Title>Listagem de CNPJs adicionais:</Title>

              <Table
                dataSource={cnpjsSecundarios}
                columns={columns}
                pagination={false}
                rowKey="index"
              />
            </>
          ) : (
            <Title>
              <Spin />
            </Title>
          )}
        </Row>
      </Modal>
    </>
  );
}

ModalCnpjsSecundarios.propTypes = {
  arrayCnpjsSecundarios: PropTypes.objectOf(PropTypes.object),
  showModalCnpjsSecundario: PropTypes.bool.isRequired,
  handleCloseModalCnpjsSecundario: PropTypes.func.isRequired,
};

ModalCnpjsSecundarios.defaultProps = {
  arrayCnpjsSecundarios: {},
};
